import { render } from "./UserSettings.vue?vue&type=template&id=ede14fa2&scoped=true"
import script from "./UserSettings.vue?vue&type=script&lang=ts"
export * from "./UserSettings.vue?vue&type=script&lang=ts"

import "./UserSettings.vue?vue&type=style&index=0&id=ede14fa2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ede14fa2"

export default script